




















































































import Vue from 'vue';
import { draggableDelay } from '@/web/utils/draggable';
import draggable from 'vuedraggable';
import PlaylistModal from '@/web/components/playlists/PlaylistModal';
import { errorToMessage } from '@/core/utils/errors';
import PlaylistsPanelTeacherItemCard from '@/web/components/playlists/PlaylistsPanelTeacherItemCard';

export default Vue.extend({
  name: 'PlaylistContentPanel',
  components: {
    PlaylistsPanelTeacherItemCard,
    draggable,
  },
  data() {
    return {
      draggableDelay,
      hover: false,
      sortedPlaylistContent: [],
    };
  },
  props: {
    playlist: {
      type: Object as () => PlaylistResponse,
    },
    playlists: {
      type: Array as () => PlaylistResponse[],
    },
  },
  computed: {
    playlistItemsCount() {
      return `${this.playlist.content.length}
				${this.$tc('PRODUCTS.TEXT.ITEMS_VARIANT', this.playlist.content.length)}`;
    },
  },
  methods: {
    async reorderContent(): Promise<void> {
      const content = this.sortedPlaylistContent.map((c, index) => {
        return {
          media_id: c.id,
          position: index,
        } as ReorderContentRequest;
      });

      await this.$store.dispatch('product/reorderPlaylistContent', {
        productId: this.playlist.product,
        playlistId: this.playlist.id,
        content: content,
      });
    },
    editPlaylist() {
      this.$modal.show(PlaylistModal, {
        playlist: this.playlist,
        playlists: this.playlists,
        mediaItemsSelected: this.mediaItemsSelected,
        confirm: playlist => this.$emit('updatePlaylist', playlist),
        delete: playlist => this.deletePlaylist(),
      });
    },
    deletePlaylist() {
      this.$emit('deletePlaylist', this.playlist.id);
    },
    addMedia() {
      this.$emit('showAddMediaFormPlaylistPanel');
    },
    async deleteMedia(media) {
      try {
        await this.$store.dispatch('product/deletePlaylistContent', {
          productId: this.playlist.product,
          playlistId: this.playlist.id,
          contentId: media.id,
        });

        this.sortedPlaylistContent = this.sortedPlaylistContent.filter(
          item => item.id !== media.id
        );

        this.$emit('selectedPlaylistContentRemoved', media.id);

        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('PRODUCTS.MODAL.THE_MEDIA_WAS_SUCCESSFULLY_DELETED'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('PRODUCTS.MODAL.FAILED_TO_DELETE_A_MEDIA'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      }
    },
    sortPosition(items) {
      this.sortedPlaylistContent = items.sort(
        (a, b) => a.position - b.position
      );
    },
  },
  // mounted() {
  //   this.sortPosition([...this.playlist.content]);
  // },
  watch: {
    'playlist.content': {
      handler: function (val) {
        this.sortPosition([...val]);
      },
      immediate: true,
      deep: true,
    },
  },
});
